<template lang="pug">
  div
    v-layout(justify-start align-center wrap :class="textClass")
      v-flex(xs2).my-0.py-0
        v-icon.dispositivos-icon(:color="iconColor") {{ icon }}
      v-flex(xs10).my-0.py-0
        .dispositivos-label {{ label }}
      v-flex(xs2).my-0.py-0
      v-flex(xs10).my-0.py-0
        .dispositivos-tempo {{ computedDate }} às {{ computedTime }}
</template>

<script>
import Moment from 'moment';

export default {
  name: 'Dispositivo',
  computed: {
    iconColor() {
      return this.status ? 'dashboardSuccess' : 'dashboardError';
    },
    textClass() {
      return this.status ? 'dashboardSuccess--text' : 'dashboardError--text';
    },
    computedDate() {
      return Moment(this.date).format('DD/MM/YYYY');
    },
    computedTime() {
      return Moment(this.date).format('HH:mm');
    },
  },
  props: {
    status: {
      type: Boolean,
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass">
  .dispositivos-label
    font-weight: 900
    font-size: 1.8vh
    line-height: 2.1vh
  .dispositivos-tempo
    font-size: 1.2vh
    line-height: 1.4vh
    color: #BFBFBF
  .dispositivos-icon
    font-size: 2.4vh
</style>



// WEBPACK FOOTER //
// src/app/Dashboard/components/Dispositivo.vue